import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function PhotographerApplicationReceivedPage() {
  return <>
      <SEO title="Application Received — Aspect" description="Your photographer application has been received. We'll review and follow up within five business days if there's a fit." data-id="element-568" />
      <div className="max-w-2xl" data-id="element-569">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-16 text-aspect-black" data-id="element-570">
          Application received
        </h1>

        <div className="space-y-16" data-id="element-571">
          <section data-id="element-572">
            <p className="text-lg text-aspect-black/80 leading-relaxed" data-id="element-573">
              We've received your photographer application.
            </p>
          </section>

          <section className="space-y-4" data-id="element-574">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-575">
              What happens next
            </h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-576">
              We review portfolios based on project types, geographic coverage,
              and upcoming needs.
            </p>
          </section>

          <section className="space-y-4" data-id="element-577">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-578">Timing</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-579">
              If there's a fit, we'll follow up within five business days.
            </p>
          </section>

          <section className="space-y-4" data-id="element-580">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-581">Reference</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-582">
              Information on assignments, rights, and compensation is available
              in the{' '}
              <Link to="/faq#photographers" className="text-aspect-black underline hover:text-aspect-black/70" data-id="element-583">
                Photographer FAQs
              </Link>
            </p>
          </section>
        </div>
      </div>
    </>;
}